import { Injectable } from "@angular/core"
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router"
import { Observable } from "rxjs"
import { StudentService } from "../services/student.service"
import { JoinedRoster } from "../models/student-site/joined-roster.model"

@Injectable()
export class StudentClassesResolver implements Resolve<JoinedRoster> {
    constructor(private studentService: StudentService) {}

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        return this.studentService.getClasses()
    }
}
